import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { FormLoader, Button, Snackbar } from '@teamfabric/copilot-ui';
import { useAuth } from 'contexts/auth';
import { useDynamicSchema } from 'utils/dynamicSchema';
import SchemaIntroList from 'components/DynamicSchemas/SchemaIntroList';

const StyledContainer = styled.div`
  margin-top: 50px;
  .wrapper-add-schema {
    display: flex;
    justify-content: center;
  }
`;

const DynamicSchemaList: React.FunctionComponent<Object> = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data, error, loading } = useDynamicSchema(user?.accountId);

  return (
    <StyledContainer>
      {loading && <FormLoader rowCount={1} theme="dark" />}
      {!loading && error?.message && (
        <>
          <Snackbar height="60px" kind="alert" label={error.message} show />
        </>
      )}
      {!loading && !error?.message && !data.Schema && (
        <div className="wrapper-add-schema">
          <Button
            onClick={() => {
              navigate('/schema/details');
            }}
            text="Add schema file"
            size="small"
          />
        </div>
      )}
      {!loading && !error?.message && data.Schema && <SchemaIntroList schemas={[data.Schema]} />}
    </StyledContainer>
  );
};

export default DynamicSchemaList;
